export const LEVIATHAN_LAUNCH_TARGET_MS = new Date(
  "2026-09-14T14:00:00-07:00"
).getTime();

export type LeviathanCountdown = {
  days: number;
  hours: number;
  minutes: number;
  seconds: number;
};

export type HomepageCountdownProps = {
  initialLeviathanCountdown: LeviathanCountdown | null;
};

export function getLeviathanCountdown(
  nowMs: number,
  targetMs = LEVIATHAN_LAUNCH_TARGET_MS
): LeviathanCountdown {
  const remainingMs = Math.max(0, targetMs - nowMs);

  const totalSeconds = Math.floor(remainingMs / 1000);
  return {
    days: Math.floor(totalSeconds / 86400),
    hours: Math.floor((totalSeconds % 86400) / 3600),
    minutes: Math.floor((totalSeconds % 3600) / 60),
    seconds: totalSeconds % 60,
  };
}

// The countdown shows wherever the release is held for this visitor. The
// deployment never decides it; the `site-open` gate does (src/server/flags.ts).
export function getInitialLeviathanCountdown(
  nowMs: number,
  releaseApproved: boolean,
  targetMs = LEVIATHAN_LAUNCH_TARGET_MS
): LeviathanCountdown | null {
  if (releaseApproved) return null;
  return getLeviathanCountdown(nowMs, targetMs);
}

export function getHomepageCountdownProps(
  nowMs: number,
  releaseApproved: boolean,
  targetMs = LEVIATHAN_LAUNCH_TARGET_MS
): HomepageCountdownProps {
  return {
    initialLeviathanCountdown: getInitialLeviathanCountdown(
      nowMs,
      releaseApproved,
      targetMs
    ),
  };
}
